import { ReportSearchDTO } from '../api'

export class ReportSearchRequest implements ReportSearchDTO {

}
